/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ReactivateResponse interface.
 */
export function instanceOfReactivateResponse(value) {
    if (!('cancelAtPeriodEnd' in value) || value['cancelAtPeriodEnd'] === undefined)
        return false;
    if (!('currentPeriodEnd' in value) || value['currentPeriodEnd'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    return true;
}
export function ReactivateResponseFromJSON(json) {
    return ReactivateResponseFromJSONTyped(json, false);
}
export function ReactivateResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'cancelAtPeriodEnd': json['cancel_at_period_end'],
        'currentPeriodEnd': json['current_period_end'],
        'status': json['status'],
    };
}
export function ReactivateResponseToJSON(json) {
    return ReactivateResponseToJSONTyped(json, false);
}
export function ReactivateResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'cancel_at_period_end': value['cancelAtPeriodEnd'],
        'current_period_end': value['currentPeriodEnd'],
        'status': value['status'],
    };
}
